import React from 'react';
import { DjayIllustrationProps } from '../types';
import { DjayIllustrationBase } from '../DjayIllustrationBase';
import { DjaySpecimen } from '../../DjaySpecimen';
export function MillenniumIllustration({
  variant = 'default',
  isUnlocked,
  rarity,
  size = 'md',
  animate = true,
  className = ''
}: DjayIllustrationProps) {
  return <DjayIllustrationBase isUnlocked={isUnlocked} rarity={rarity} size={size} className={className} data-id="element-3995" data-mp="30qrkz2mm8bl2">
      <div className="relative w-full h-full bg-gradient-to-br from-fuchsia-300 via-pink-400 to-rose-500 overflow-hidden" data-id="element-3996" data-mp="3annwzibq3fud">
        {/* Background: Fireworks bursts */}
        <svg className="absolute inset-0 w-full h-full z-0" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3997" data-mp="3fnimbhfunxdb">
          <g transform="translate(50, 45)" opacity="0.6" data-id="element-3998" data-mp="1la17citig8tw">
            {[...Array(8)].map((_, i) => <path key={i} d="M0 0 L0 -22" stroke="#FDE047" strokeWidth="2" strokeLinecap="round" transform={`rotate(${i * 45})`} data-id="element-3999" data-mp="1pb30qj0qxqny" data-mpi={i} />)}
          </g>
          <g transform="translate(155, 55)" opacity="0.6" data-id="element-4000" data-mp="p2r18yqle5sm">
            {[...Array(8)].map((_, i) => <path key={i} d="M0 0 L0 -16" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" transform={`rotate(${i * 45})`} data-id="element-4001" data-mp="k4z2plvfzlfg" data-mpi={i} />)}
          </g>
        </svg>

        {/* Djay */}
        <div className="absolute inset-0 z-10 flex items-center justify-center pt-[8%]" data-id="element-4002" data-mp="17sqp5iap5eug">
          <div className="w-[66%] h-[66%] flex items-center justify-center" data-id="element-4003" data-mp="12vgsbhkza0wl">
            <DjaySpecimen look={{
            variant,
            accessory: 'tripleStars'
          }} size="hero" emotion={isUnlocked ? 'excited' : 'sleeping'} animate={animate && isUnlocked} className="w-full h-full" data-id="element-4004" data-mp="3sjr6zsx0u4d7" />
          </div>
        </div>

        {/* Foreground: "1000" banner */}
        {isUnlocked && <svg className="absolute inset-0 w-full h-full z-20 pointer-events-none" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-4005" data-mp="25nt3bb8dp1v2">
            <path d="M-10 150 Q100 178 210 150 L210 200 L-10 200 Z" fill="#BE185D" opacity="0.85" data-id="element-4006" data-mp="1vwf5r8zzmc4k" />
            <text x="100" y="184" textAnchor="middle" fontFamily="sans-serif" fontSize="26" fontWeight="900" fill="#FDE047" data-id="element-4007" data-mp="20q1c6jfk5jrx">
              1000
            </text>
          </svg>}
      </div>
    </DjayIllustrationBase>;
}